// extracted by mini-css-extract-plugin
export default {"title":"account-card_title__zOayN","text":"account-card_text__hmJbA","separator":"account-card_separator__SR2pH"};